export default __webpack_public_path__ + "static/media/dropdown-arrow-down.cc641d71.svg";